<script setup>

/*==================================================================*/
/*================== VUE IMPORTS ===================================*/
/*==================================================================*/

import { defineProps, useSlots, computed } from 'vue';
import CartaoBase from '@/components/v2/base/CartaoBase/CartaoBase.vue';
import TabelaBase from '@/components/v2/base/TabelaBase/TabelaBase.vue';

/*==================================================================*/
/*================== PROPS =========================================*/
/*==================================================================*/

const props = defineProps({
    headers: {
        type: Array,
        default: () => []
    },
    dados: {
        type: Array,
        default: () => []
    },
    disabled: {
        type: Boolean,
        default: false
    }
});

const slots = useSlots();

/*==================================================================*/
/*================== SLOTS DE ITEM =================================*/
/*==================================================================*/

const slotsDeItem = computed(() =>

    Object.keys(slots).filter(name => name.startsWith('linha-item.'))

);

</script>

<template>

    <CartaoBase>

        <template #header>
            <slot name="header"></slot>
        </template>

        <template #body>

            <TabelaBase :headers="props.headers" :dados="props.dados" :disabled="props.disabled">

                <template #linha-botoes="slotProps">

                    <slot name="linha-botoes" v-bind="slotProps"></slot>

                </template>

                <template
                    v-for="name in slotsDeItem"
                    #[name]="slotProps"
                >

                    <slot :name="name" v-bind="slotProps ?? {}"></slot>

                </template>
                
            </TabelaBase>

        </template>

        <template #footer>
            <slot name="footer"></slot>
        </template>

    </CartaoBase>

</template>

<style scoped>
</style>
